<template>
  <div>
    <a-modal
      centered
      v-model="visible"
      title="房价日历"
      :width="width"
      @ok="visible = false"
      :maskClosable="false"
      :destroyOnClose="true"
    >
      <div style="margin-top:10px; " ref="priceContent">
        <span class="zoom-in" @click="openAll"
          ><a-icon :type="zoomType" size="20"
        /></span>
        <div style="text-align:right">
          <a-radio-group
            v-model="selMonth"
            @change="onChangeMonth"
            buttonStyle="solid"
            style="float: left;"
          >
            <a-radio-button
              v-for="mon in MonthButtonArr"
              :value="mon.month"
              :key="mon.month"
              >{{ mon.month }}月</a-radio-button
            >
          </a-radio-group>
          <a-date-picker
            style="width:140px"
            v-model="startDate"
            @change="changeStartDate"
            format="YYYY-MM-DD"
            :allowClear="false"
          />
          -
          <a-date-picker
            v-model="endDate"
            :disabledDate="disabledEndDate"
            @change="changeEndDate"
            :allowClear="false"
            format="YYYY-MM-DD"
            style="width:140px;margin-right:10px"
          />
          <a-button type="primary" @click="search">搜索</a-button>
        </div>
        <DataGrid
          id="calendarPriceTable"
          :columns="columnsRoomPrice"
          :data="priceData"
          bordered
          style="margin-top:20px;min-height:300px"
          :props="{
            scroll: { y: scrollY, x: this.tableLength }
          }"
          :loading="loading"
          :pagination="false"
          rowKey="Id"
          size="small"
        ></DataGrid>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";
import { cache } from "@/utils/common";
import { DataGrid } from "@/components/dataGrid";
export default {
  name: "PriceCalendar",
  components: { DataGrid },
  props: {},
  data() {
    return {
      editId: "",
      visible: false,
      columns: [],
      data: [],
      //以下是房价日历数据
      tableLength: "", //x轴横向滑动长度
      priceData: [],
      columnsRoomPrice: [],
      monthData: [],
      MonthButtonArr: [],
      loading: false,
      startDate: null,
      endDate: null,
      selMonth: "",
      accountDate: "",
      zoomType: "zoom-in",
      width: "80%",
      scrollY: 430,
      specialPrices: [],
      dataRecord: {}
    };
  },
  created() {
    this.accountDate = cache.get("user").AccountDate;
  },
  mounted() {},
  methods: {
    changeSpecialColor() {
      const _this = this;
      this.$nextTick(() => {
        this.priceData.forEach((el, index) => {
          const basePrice = _this.dataRecord[el.key];
          for (let i in el) {
            if (i != "text" && i != "key") {
              let nowPrice = el[i];
              let colIndex = Number(i.split("col")[1]);
              const target = document
                .querySelectorAll("#calendarPriceTable tr")
                [index + 1].querySelectorAll("td")[colIndex + 1];
              if (basePrice != nowPrice) {
                this.$common.addClass(target, "is-special");
              } else {
                this.$common.removeClass(target, "is-special");
              }
            }
          }
        });
      });
    },
    //结束时间选择范围
    disabledEndDate(endValue) {
      return endValue && endValue < this.startDate.startOf("day");
    },
    changeStartDate(value) {
      this.endDate = moment(value).add(3, "months");
      this.selMonth = "";
      this.reloadData(value, this.endDate);
    },
    changeEndDate(value) {
      this.selMonth = "";
      this.reloadData(this.startDate, value);
    },
    show(record) {
      this.width = "80%";
      this.selMonth = "";
      this.visible = true;
      this.loading = true;
      this.priceData = [];
      this.columnsRoomPrice = [];
      this.data = [];
      this.columns = [];
      this.specialPrices = [];
      this.startDate = moment(this.accountDate);
      this.endDate = moment(this.accountDate).add(3, "months");
      this.$post("PriceSystem_Get", { id: record.Id }).then(res => {
        let row = {};
        res.Data.BasePriceDetails.forEach(item => {
          row[item.RoomTypeId] = item.Price;
        });
        this.data.push(row);
        this.columns = res.Data.BasePriceDetails.map(item => {
          return {
            title: item.RoomTypeName,
            dataIndex: item.RoomTypeId,
            width: "120px"
          };
        });
        this.dataRecord = { ...this.data[0] };
        this.loadRoomPriceTable();
        this.specialPrices = res.Data.RoomTypeSpecialPrices;
        this.updateMonthData(this.specialPrices);
        this.loading = false;
        this.$nextTick(() => {
          this.resetModal();
          this.changeSpecialColor();
        });
      });
    },
    //初始化特殊房价表格
    loadRoomPriceTable() {
      this.MonthButtonArr = [];
      let curMon = moment(this.accountDate).month() + 1;
      let start = moment(this.accountDate).format("YYYY-MM-DD");
      let end = moment(start)
        .endOf("month")
        .format("YYYY-MM-DD");
      for (let i = 0; i < 12; i++) {
        this.MonthButtonArr.push({
          month: curMon,
          start: start,
          end: end
        });
        curMon++;
        if (curMon > 12) {
          curMon = 1;
        }
        start =
          moment(start)
            .add("months", 1)
            .format("YYYY-MM") + "-01";
        end = moment(start)
          .endOf("month")
          .format("YYYY-MM-DD");
      }
      this.reloadData(this.accountDate, this.endDate);
    },
    createColumns(startDate, endDate, dayNum) {
      let columns = [
        {
          title: "房型",
          width: 200,
          dataIndex: "text",
          fixed: "left",
          align: "center"
        }
      ];
      this.tableLength = 1500 + dayNum * 80;
      for (let i = 0; i < dayNum; i++) {
        const date = moment(startDate).add(i, "days");
        const field = "col" + i;
        const columnItem = {
          title: date.format("MM-DD (dd)"),
          date: date.format("YYYY-MM-DD"),
          width: Math.round((this.tableLength - 200) / dayNum),
          dataIndex: field,
          align: "center"
        };
        columns.push(columnItem);
      }
      return columns;
    },
    createData(dayNum) {
      let rows = [];
      let baseRoomTypePrice = this.data[0];
      for (let x = 0; x < this.columns.length; x++) {
        const row = {};
        //房型名称
        row["text"] = this.columns[x].title;
        row["key"] = this.columns[x].dataIndex;
        //获取对应的基础价格
        let basePrice = "";
        for (const key in baseRoomTypePrice) {
          if (key == this.columns[x].dataIndex) {
            basePrice = baseRoomTypePrice[key];
            break;
          }
        }
        //所有特殊房价设置默认基础房价  展示
        for (let i = 0; i < dayNum; i++) {
          const field = "col" + i;
          row[field] = basePrice;
        }
        rows.push(row);
      }
      return rows;
    },
    //批量修改 和 编辑进来的  单独更新房价日历 特殊房价
    updateMonthData(RoomTypeSpecialPrices) {
      RoomTypeSpecialPrices.forEach(item => {
        //特殊修改过的，找到某一天，再通过房型匹配
        item.RoomPriceDetails.forEach(el => {
          const col = this.columnsRoomPrice.find(
            ele => ele.date == el.PriceDate
          );
          if (col) {
            let target = this.priceData.find(dat => dat.key == item.RoomTypeId);
            target[col.dataIndex] = el.Price;
          }
        });
      });
    },
    onChangeMonth(e) {
      const mon = e.target.value;
      const cur = this.MonthButtonArr.find(el => el.month == mon);
      this.reloadData(cur.start, cur.end);
      this.changeSpecialColor();
    },
    reloadData(start, end) {
      const days = moment(end).diff(start, "days") + 1;
      this.columnsRoomPrice = this.createColumns(start, end, days);
      this.priceData = this.createData(days);
      this.updateMonthData(this.specialPrices);
    },
    search() {
      this.reloadData(this.startDate, this.endDate);
      this.selMonth = "";
    },
    openAll() {
      if (this.zoomType == "zoom-in") {
        this.zoomType = "zoom-out";
        this.width = "100%";
        // this.scrollY = 350;
        this.$refs.priceContent.style = "height:calc(100vh - 140px)";
        this.scrollY = this.$refs.priceContent.clientHeight - 50;
      } else {
        this.resetModal();
      }
    },
    resetModal() {
      this.zoomType = "zoom-in";
      this.width = "80%";
      this.$refs.priceContent.style = "height:auto";
      this.scrollY = 430;
    }
  }
};
</script>
<style lang="less" scoped>
table {
  width: 100%;
  text-align: left;
  tr {
    td {
      width: 25%;
      padding: 5px;
      text-align: left;
      span {
        display: inline-block;
        width: 75px;
        text-align: justify;
        text-align-last: justify;
        padding-left: 5px;
      }
      .time {
        width: 140px;
        padding-left: 0;
      }
      input {
        width: 140px;
      }
    }
  }
}
.zoom-in {
  position: absolute;
  right: 60px;
  top: 18px;
  cursor: pointer;
  i {
    font-size: 24px;
  }
}
#calendarPriceTable /deep/ .ant-table-tbody > tr > td.is-special {
  background: #f8fdff;
  color: #00b1c7;
}
</style>
